function variantOnChange(name) {

  if (name == "Color") {
    if (document.getElementsByName("options[Color]")[0].selectedIndex != 0) {
      document.getElementById("oi-color-code-input").value = "";
      document.getElementById("oi-custom-color-code").value = "";
    }
  } else if (name == "Which Side") {
    document.getElementById("oi-color-code-input").value = "";
    document.getElementById("oi-custom-color-code").value = "";

    // if (document.getElementById("oi-color-code-input").value != "") {
    //   let urlParameters = new URLSearchParams(location.search);
    //   let variantId = document.getElementsByName("options[Which Side]")[0].value.includes("Left")
    //     ? meta.product.variants.find((x) => x["public_title"].includes("Left")).id
    //     : meta.product.variants.find((x) => x["public_title"].includes("Right")).id;
    //   urlParameters.set("variant", variantId);
    //   for (let idInput of document.querySelectorAll("input[name=id][type=hidden]")) {
    //     idInput.value = variantId;
    //   }
    //   history.replaceState(null, '', '?' + urlParameters.toString());
    //   document.getElementsByName("options[Color]")[0].selectedIndex = 0;
    // }
  }
}

document.getElementById("oi-color-code-input").onchange = () => {
  if (document.getElementById("oi-color-code-input").value != "") {
    document.getElementsByName("options[Color]")[0].selectedIndex = 0;
    let urlParameters = new URLSearchParams(location.search);
    let variantId;
    if (document.getElementsByName("options[Which Side]").length > 0) {
      variantId = document.getElementsByName("options[Which Side]")[0].value.includes("Left")
        ? meta.product.variants.find((x) => x["public_title"].includes("Left")).id
        : meta.product.variants.find((x) => x["public_title"].includes("Right")).id;
    } else {
      variantId = meta.product.variants.find((x) =>
        x["public_title"].toLowerCase().replaceAll(" ", "").includes("enteratcheckout")
        || x["public_title"].toLowerCase().replaceAll(" ", "").includes("enterbelow")
      ).id
    }
    urlParameters.set("variant", variantId);
    for (let idInput of document.querySelectorAll("input[name=id][type=hidden]")) {
      idInput.value = variantId;
    }
  }
}